import BaseFormPresenter from "../../../../base/BaseFormPresenter";

export default class EditProfileFormPresenter extends BaseFormPresenter {
  async save() {
    const collection = this.view.getCollectionName();
    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }

    try {
      await this.upsertUseCase.execute(collection, this.change);
      this.change = {};
    } catch (error) {
      throw error;
    }
  }
}
